import type { ReactNode } from "react";

export type Tone = "neutral" | "ok" | "warn" | "danger" | "accent";

const TONE: Record<Tone, string> = {
  neutral: "border-line text-ink",
  ok: "border-ok text-ok",
  warn: "border-warn text-warn",
  danger: "border-danger text-danger",
  accent: "border-accent text-accent",
};

const MARK: Record<Tone, string> = { neutral: "•", ok: "✓", warn: "!", danger: "✕", accent: "→" };

/**
 * A state, in words. The colour and the mark reinforce the text and never
 * replace it (accessibility-plan.md §9: states are words, never a coloured
 * dot alone); the mark is decorative to assistive technology.
 */
export function StatusPill({ tone = "neutral", children }: { tone?: Tone; children: ReactNode }) {
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full border bg-surface px-2.5 py-0.5 text-sm font-medium ${TONE[tone]}`}>
      <span aria-hidden="true">{MARK[tone]}</span>
      {children}
    </span>
  );
}
